/* eslint-disable react-hooks/exhaustive-deps */
import {
  Alert,
  Avatar,
  Box,
  Button,
  CircularProgress,
  Typography,
} from '@mui/material';
import { Table, Page } from '../../design';
import { useRequester } from '../../hooks';
import { useContext, useEffect } from 'react';
import { Add as AddIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { TutorResource } from '../../resources';
import { AuthContext } from '../../contexts';
import { Searchbar } from '../../design';

interface Row {
  id: string;
  name: string;
  avatar: string;
  voiceEn: string;
  voiceJp: string;
  tags: string[];
  color: string;
}

function NameCell(props: Row) {
  console.log(props);

  return (
    <Box className="flex items-center gap-4">
      <Avatar src={props.avatar} sx={{ outline: '2px solid', outlineColor: props.color || 'transparent' }} />
      <Typography variant="h6" color="text.primary">
        {props.name}
      </Typography>
    </Box>
  );
}

function TagsCell(props: Row) {
  return <Box className="flex justify-end gap-2">
    <Typography variant="body2" color="text.primary">{props.tags?.slice(0, 5).join(', ')}</Typography>
    {props.tags?.length > 5 && <Typography variant="body2" color="text.secondary">+{props.tags.length - 5} more</Typography>}
  </Box>;
}


const columns = [
  { id: 'name', label: 'Name', Component: NameCell },
  { id: 'voiceEn', label: 'Voice (EN)', align: 'center' },
  { id: 'voiceJp', label: 'Voice (JP)', align: 'center' },
  { id: 'tags', label: 'Tags', Component: TagsCell, align: 'right' },
];

const toRow = (ob: TutorResource): Row => {
  const data = ob.data;

  return {
    id: data.id,
    name: `${data.name} (${data.identification})`,
    avatar: data.avatar,
    voiceEn: data.voice.code,
    voiceJp: data.voiceJp.code,
    tags: data.tags,
    color: data.color,
  };
};

export default function TutorsPage() {
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);


  const tutorsApi = useRequester<TutorResource[]>({
    onSubmit: () => TutorResource.fetchMany({ includeSystem: true }),
    onError: console.log,
  });

  useEffect(() => {
    tutorsApi.submit();
  }, []);

  const rows = TutorResource.list().map(toRow);

  return (
    <Page>
      <Page.Header>
        <Box className="flex flex-col h-full">
          <Typography variant="body1" color="text.secondary" sx={{ mt: 8 }}>
            👋 Hey, {user?.data.firstName}!
          </Typography>
          <Typography variant="h1">AI Tutors</Typography>
          <Box className="flex-grow"></Box>
        </Box>
      </Page.Header>
      <Page.Content>
        <Box className="flex justify-between mt-8 mb-8">
          <Box className="flex gap-4 flex-grow">
            <Searchbar disabled placeholder="Search for a tutor" onChange={(qs) => { }} />
            {tutorsApi.loading && (
              <Box className="flex items-center">
                <CircularProgress size={20} />
              </Box>
            )}
            <Box className="flex-grow"></Box>
            <Button
              variant="contained"
              endIcon={<AddIcon />}
              onClick={() => navigate('/tutors/new')}
            >
              New Tutor
            </Button>
          </Box>
        </Box>

        {tutorsApi.error ? (
          <Alert severity="error">{tutorsApi.error}</Alert>
        ) : (
          <Table
            // @ts-ignore
            columns={columns}
            rows={rows}
            onRowClick={(row) => navigate(`/tutors/${row.id}`)}
            onEdit={(row) => navigate(`/tutors/${row.id}/edit`)}
          />
        )}
      </Page.Content>
    </Page>
  );
}
